import { handleCreateNewChat } from "../redux/user-slices/chat.slice"
import { setCurrectChat, setAppointmentAvailability } from "../redux/user-slices/socket.slice"
import { useDispatch, useSelector } from "react-redux"
import { checkUserType } from "../utils/helper"
import { useNavigate } from "react-router-dom"
import { useToast } from "./useToast"

export const useChatInitiate = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const userType = checkUserType()
  const { chat, socket } = useSelector((state) => state.socketSlice)
  const { member, specialist } = useSelector((state) => state.authSlice)
  const currentUserId = member?._id || specialist?._id || specialist?.specialist?._id
  const toast = useToast()

  const initiateGeneralChat = async (receiver) => {
    if (!userType) {
      toast.error("Please log in to start a chat.");
      return null;
    }

    try {
      const result = await dispatch(
        handleCreateNewChat({
          receiver,
          type: "general",
        })
      ).unwrap() || {}

      const chat = result?.data?.chat || result?.data || result?.chat;

      if (chat) {
        dispatch(setCurrectChat(chat))
        socket.emit("join-room", chat?._id)
        navigate(`/${userType}/profile/messages`, { state: chat })
      }

      return chat
    } catch (error) {
      console.error("Error initiating general chat:", error)
      let errorMsg = error?.error || error?.response?.data?.error || "Error initiating chat";
      if (typeof errorMsg === "string" && errorMsg.toLowerCase().includes("token")) {
        errorMsg = "Please log in to start a chat.";
      }
      toast.error(errorMsg);
    }
  }

  const initiateAppointmentChat = async (appointment) => {
    if (!userType) {
      toast.error("Please log in to start a chat.");
      return null;
    }

    try {
      const now = new Date();
      const startTime = new Date(appointment?.startTime);
      if (now < startTime) {
        toast.error("Chat is not available yet. It will open at the scheduled appointment time.");
        return null;
      }

      const memberIdStr = (appointment?.memberId?._id || appointment?.memberId || appointment?.member?._id || appointment?.memberInfo?._id || "").toString();
      const specialistIdStr = (appointment?.specialistId?._id || appointment?.specialistId || appointment?.specialistInfo?._id || "").toString();
      
      const receiver = memberIdStr === currentUserId?.toString()
        ? (appointment?.specialistId?._id || appointment?.specialistId || appointment?.specialistInfo?._id)
        : (appointment?.memberId?._id || appointment?.memberId || appointment?.member?._id || appointment?.memberInfo?._id);

      const result = await dispatch(
        handleCreateNewChat({
          type: "appointment",
          appointmentId: appointment?._id,
          receiver,
        })
      ).unwrap() || {}

      const chat = result?.data?.chat || result?.data || result?.chat;

      if (chat) {
        if (appointment?.startTime && appointment?.endTime) {
          dispatch(setAppointmentAvailability({
            startTime: appointment.startTime,
            endTime: appointment.endTime,
            timeZone: appointment.timezone || appointment.timeZone,
          }))
        }
        dispatch(setCurrectChat(chat))
        socket.emit("join-room", chat?._id)
      }

      return chat
    } catch (error) {
      console.error("Error initiating appointment chat:", error)
      let errorMsg = error?.error || error?.response?.data?.error || "Error initiating chat";
      if (typeof errorMsg === "string" && errorMsg.toLowerCase().includes("token")) {
        errorMsg = "Please log in to start a chat.";
      }
      toast.error(errorMsg);
    }
  }

  return {
    initiateGeneralChat,
    initiateAppointmentChat,
    isGeneral: chat?.type === "general",
    isAppointment: chat?.type === "appointment",
    isActive: !!Object.keys(chat || {})?.length,
  }
}